import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/DocumentPanel.css';

export default function DocumentPanel({ doc, onClose, onModeChange, onOpenConversation }) {
  const navigate = useNavigate();
  const [downloading, setDownloading] = useState(null);
  const [downloadError, setDownloadError] = useState(null);

  if (!doc) return null;

  const isReady = doc.state === 'ready' && doc.document;

  const handleDownload = async (format) => {
    setDownloading(format);
    setDownloadError(null);
    try {
      const response = await fetch(`/api/jobs/${doc.job_id}/convert?format=${format}`, {
        credentials: 'include',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('session_token')}`
        }
      });
      if (response.status === 429) {
        setDownloadError('Too many downloads — wait a few minutes.');
        return;
      }
      if (response.status === 500) {
        setDownloadError(`Can't convert to ${format.toUpperCase()} right now. Try Word or Text.`);
        return;
      }
      if (!response.ok) throw new Error('Download failed');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const safeName = doc.title.slice(0, 50).replace(/[^a-zA-Z0-9_-]/g, '_');
      a.download = `${safeName}.${format}`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch {
      setDownloadError('Download failed. Please try again.');
    } finally {
      setDownloading(null);
    }
  };

  return (
    <div className="doc-panel">
      <div className="doc-panel-header">
        <h3 className="doc-panel-title">Quick Actions</h3>
        {onClose && (
          <button className="doc-panel-close" onClick={onClose}>×</button>
        )}
      </div>

      <div className="doc-panel-content">
        <div className="doc-panel-actions">
          {isReady && (
            <>
              <button
                className="doc-panel-btn"
                onClick={() => handleDownload('pdf')}
                disabled={downloading === 'pdf'}
              >
                {downloading === 'pdf' ? '⏳ Downloading…' : '📕 Download PDF'}
              </button>
              <button
                className="doc-panel-btn"
                onClick={() => handleDownload('docx')}
                disabled={downloading === 'docx'}
              >
                {downloading === 'docx' ? '⏳ Downloading…' : '📝 Download Word'}
              </button>
              <button
                className="doc-panel-btn"
                onClick={() => handleDownload('txt')}
                disabled={downloading === 'txt'}
              >
                {downloading === 'txt' ? '⏳ Downloading…' : '📄 Download Text'}
              </button>
            </>
          )}
          {doc.conversation_id && (
            <button
              className="doc-panel-btn"
              onClick={() => onOpenConversation && onOpenConversation(doc.conversation_id)}
            >
              💬 Open Conversation
            </button>
          )}
          <button
            className="doc-panel-btn"
            onClick={() => navigate(`/job/${doc.job_id}`)}
          >
            📦 Job Details
          </button>
          {onModeChange && (
            <button
              className="doc-panel-btn"
              onClick={() => onModeChange('conversations')}
            >
              Return to Conversations →
            </button>
          )}
        </div>

        {downloadError && (
          <p className="doc-panel-error">{downloadError}</p>
        )}
      </div>
    </div>
  );
}
